module.exports = __webpack_public_path__ + "static/media/logo.994628fa.png";